import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { ManagerDashboardComponent } from './components/manager-dashboard/manager-dashboard.component';
import { AddUserTagComponent } from './components/add-user-tag/add-user-tag.component';
import { TakeAssessmentComponent } from './components/take-assessment/take-assessment.component';
import { HrDashboardComponent } from './components/hr-dashboard/hr-dashboard.component';
import { ViewProgressComponent } from './components/view-progress/view-progress.component';
import { ThankYouComponent } from './components/thank-you/thank-you.component';
import { RegisterDashboardComponent } from './components/register-dashboard/register-dashboard.component';
import { AddTeamComponent } from './components/add-team/add-team.component';
import { AddUserComponent } from './components/add-user/add-user.component';
import { UpdatePasswordComponent } from './components/update-password/update-password.component';
import { TeamUsersComponent } from './team-users/team-users.component';
import { HierarchyComponent } from './components/hr-dashboard/hierarchy/hierarchy.component';
import { UserDetailComponent } from './components/hr-dashboard/user-detail/user-detail.component';
import { UserProfileComponent } from './components/user-profile/user-profile.component';

const routes: Routes = [

  // Redirect root → requires tenant
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // Tenant-aware routes
  {
    path: ':tenant',
    children: [

      { path: 'login', component: LoginComponent },

      {
        path: 'team/:teamId',
        component: TeamUsersComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'user-dashboard',
        component: UserDashboardComponent,
        canActivate: [AuthGuard],
        data: { role: 'user' }
      },

      {
        path: 'manager-dashboard',
        component: ManagerDashboardComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'user-profile',
        component: UserProfileComponent,
        canActivate: [AuthGuard],
        data: { role: 'user' }
      },

      {
        path: 'add-user-tag',
        component: AddUserTagComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'assessment',
        component: TakeAssessmentComponent,
        canActivate: [AuthGuard],
        data: { role: 'user' }
      },

      {
        path: 'thankyou',
        component: ThankYouComponent,
        canActivate: [AuthGuard],
        data: { role: 'user' }
      },

      {
        path: 'view-progress',
        component: ViewProgressComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'register-dashboard',
        component: RegisterDashboardComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'add-team',
        component: AddTeamComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'add-user',
        component: AddUserComponent,
        canActivate: [AuthGuard],
        data: { role: 'manager' }
      },

      {
        path: 'hr-dashboard',
        component: HrDashboardComponent,
        canActivate: [AuthGuard],
        data: { role: 'hr' }
      },

      {
        path: 'update-password',
        component: UpdatePasswordComponent,
        canActivate: [AuthGuard],
        data: { role: ['manager', 'user', 'hr'] }
      },

      {
        path: 'hierarchy/:id',
        component: HierarchyComponent,
        canActivate: [AuthGuard],
        data: { role: ['hr'] }
      },

      {
        path: 'user-detail/:userId',
        component: UserDetailComponent,
        canActivate: [AuthGuard],
        data: { role: ['hr'] }
      },

      // Tenant-level fallback
      { path: '**', redirectTo: 'login' }
    ]
  },

  // Global fallback
  { path: '**', redirectTo: '' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
